import Vue from 'vue'
import { notification } from 'ant-design-vue';
import 'ant-design-vue/lib/notification/style/index.css' // we can change to less
Vue.prototype.$notification = notification